/**
 * @generated SignedSource<<9d4ba59f7b783d4d90a9c1b5c7d88bfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersSectionContent$data = {
  readonly fullSectionPath: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersSectionContent";
};
export type helpersSectionContent$key = {
  readonly " $data"?: helpersSectionContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersSectionContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersSectionContent"
};

(node as any).hash = "5df23160f7b8f1bbdf37c24326a35f2b";

export default node;
